import {View} from "@react-pdf/renderer";
import {SideTableRow} from "./SideTableRow";
import { styles} from "../reportingHelpers";
import React from "react";

export const SideTableRight = ({team, intl, style}) => {
  const defaults = [{
    biggestLead: 0,
    biggestScoringRun: 0,
    leadChanges: 0,
    timesScoreLevel: 0,
    timeInLead: '0',
  }];
  const teamStats = team.teamStatsPeriods ?? defaults;

  const biggestLead = teamStats.reduce((acc, stats) => stats.biggestLead > acc ? stats.biggestLead : acc, 0);
  const biggestScoringRun = teamStats.reduce((acc, stats) => stats.biggestScoringRun > acc ? stats.biggestScoringRun : acc, 0);
  const timesScoreLevel = teamStats.reduce((acc, stats) => acc + stats.timesScoreLevel, 0);
  const leadChanges = teamStats.reduce((acc, stats) => acc + stats.leadChanges, 0);

  return (
    <View style={{flexDirection: 'column', width: '65mm', borderColor: 'white', ...style}}>

      <View style={{...styles.tableRowFrench, borderColor: 'white', height: '4mm'}} />

      <SideTableRow
        labelText={intl.formatMessage({
          id: 'reports.boxscore.biggestlead',
          defaultMessage: 'Biggest Lead',
        })}
        teamText={biggestLead}
      />

      <SideTableRow
        labelText={intl.formatMessage({
          id: 'reports.boxscore.biggestrun',
          defaultMessage: 'Biggest Scoring Run',
        })}
        teamText={biggestScoringRun}
      />
      <SideTableRow
        labelText={intl.formatMessage({
          id: 'reports.boxscore.timestied',
          defaultMessage: 'Times Tied',
        })}
        teamText={timesScoreLevel}
      />
      <SideTableRow
        labelText={intl.formatMessage({
          id: 'reports.boxscore.leadchanges',
          defaultMessage: 'Lead Changes',
        })}
        teamText={leadChanges}
      />
    </View>
  );
};